import { Button, Dropdown, Form, Menu, message } from 'antd'
import { inject, observer } from 'mobx-react'
import React, { useCallback, useEffect, useMemo, useState } from 'react'
import { Helmet } from 'react-helmet/es/Helmet'
import ContentBlockWrapper from '../../components/ContentBlockWrapper'
import PageTitle from '../../components/PageTitle'
import {
  BlockLeft,
  BlockRight,
  DocumentContentWrapper,
  DocumentInfoList,
  HeadingButtonWrapper,
} from '../../layouts/ConnectedCommitteeDocumentDetailLayout/ConnectedCommitteeDocumentDetailLayoutStyled'
// PDF Viewer
import {
  CalendarOutlined,
  MoreOutlined,
  ReloadOutlined,
} from '@ant-design/icons'
import FileDownload from 'js-file-download'
import moment from 'moment'
import { useMediaQuery } from 'react-responsive'
import { blue } from '../../color'
import {
  EmptyText,
  TitleContentBox,
  WordBreak,
} from '../../components/Common/CellText'
import FileItem from '../../components/Common/FileItemComponent/FileItem'
import ConnectedCommitteeDocumentIncomingHistoryBlock from '../../components/ConnectedCommitteeDocumentIncomingHistoryBlock'
import ConnectedCommitteeDocumentUserReadingStatusModal from '../../components/ConnectedCommitteeDocumentUserReadingStatusModal'
import PDFViewer from '../../components/PDFViewer/PDFViewer'
import { systemName } from '../../config'
import {
  CATE_DOCUMENT_TYPE,
  DATE_FORMAT_DEFAULT,
  DOCUMENT_PRIORITY,
  STEERING_TYPE,
  getDOCUMENT_STATUS_RECEIVED,
} from '../../constants'
import DashboardLayout from '../../layouts/DashboardLayout/DashboardLayout'
import utils from '../../utils'

const CateDocumentIncomingDocDetailPage = props => {
  const [form] = Form.useForm()

  const {
    match,
    commonStore,
    loadingAnimationStore,
    authenticationStore,
    companyStore,
    fileStore,
    cateDocumentStore,
  } = props

  const { documentId } = match.params
  const [document, setDocument] = useState(null)
  const [attachmentForView, setAttachmentForView] = useState()

  const isTabletOrMobile = useMediaQuery({
    query: '(max-width: 1299px)',
  })

  const TextCapitalize = props => (
    <span
      style={{
        textTransform: 'capitalize',
      }}>
      {props.children}
    </span>
  )

  const {
    attachments,
    bussiness_doc_type,
    documentNumber,
    doc_id,
    document_type,
    history,
    from_organ,
    priorityId,
    promulgationDate,
    signer_info,
    statusId,
    subject,
    edocs_bussiness,
    process,
    cateDocumentStatusId,
    steeringType,
    type,
    typeName,
    fullname,
  } = document || {}
  const title = subject
  const status = statusId

  useEffect(() => {
    fetchData()
    return () => {
      form.resetFields()
    }
  }, [documentId])

  const fetchData = () => {
    loadingAnimationStore.showSpinner(true)
    cateDocumentStore
      .getDocumentsIncomingById(documentId)
      .then(response => {
        setDocument(response.data)
      })
      .catch(err => {
        props.history.push('/cate-document/incoming-document')
        console.log(err)
        message.error(err?.vi || 'Đã có lỗi xảy ra!')
      })
      .finally(() => loadingAnimationStore.showSpinner(false))
  }

  const reloadIncoming = () => {
    cateDocumentStore
      .reloadIncoming({ id: documentId })
      .then(response => {
        fetchData()
      })
      .catch(err => {
        props.history.push('/cate-document/incoming-document')
        console.log(err)
        message.error(err?.vi || 'Đã có lỗi xảy ra!')
      })
      .finally(() => loadingAnimationStore.showSpinner(false))
  }

  const handleDownloadAttachment = useCallback(
    attachmentName => {
      loadingAnimationStore.showSpinner(true)
      fileStore
        .getReceivedFileByEdocId(documentId, attachmentName)
        .then(response => {
          const blob = new Blob([response.data], { type: 'application/pdf' })
          FileDownload(blob, attachmentName)
          return Promise.resolve()
        })
        .catch(error => {
          console.log('error', error)
          return Promise.reject()
        })
        .finally(() => loadingAnimationStore.showSpinner(false))
    },
    [documentId]
  )

  const [showUserReadingModal, setShowUserReadingModal] = useState(false)

  useEffect(() => {
    if (!attachments) return
    setAttachmentForView(
      attachments.find(file =>
        ['pdf', 'doc', 'docx'].includes(utils.getExtensionFile(file.fileName))
      )
    )
  }, [attachments])

  const renderAttachmentFile = useMemo(
    () => (
      <PDFViewer
        fileId={attachmentForView?.fileId}
        file={undefined}
        customStyleObj={{ height: isTabletOrMobile ? 500 : 1000 }}
        fileType={utils.getExtensionFile(attachmentForView?.fileName)}
      />
    ),
    [attachmentForView]
  )

  const renderBussinessDocTypeName = typeId => {
    switch (typeId) {
      case '0':
        return 'Tạo văn bản mới'
      case '1':
        return 'Thu hồi văn bản đã gửi'
      case '2':
        return 'Cập nhật văn bản đã gửi'
      case '3':
        return 'Thay thế văn bản đã gửi'
      default:
        return ''
    }
  }

  const renderAction = bussiness_doc_type => {
    switch (bussiness_doc_type) {
      case '0':
        return 'tạo mới'
      case '1':
        return 'thu hồi'
      case '2':
        return 'cập nhật'
      case '3':
        return 'thay thế'
      default:
        return ''
    }
  }

  const renderDocumentTypeName = typeId => {
    switch (typeId) {
      case 1:
        return 'Văn bản quy phạm pháp luật'
      case 2:
        return 'Văn bản hành chính'
      default:
        return ''
    }
  }

  const renderPriorityName = priorityId => {
    switch (priorityId) {
      case 0:
        return 'Thường'
      case 1:
        return 'Khẩn'
      case 2:
        return 'Thượng khẩn'
      case 3:
        return 'Hỏa tốc'
      case 4:
        return 'Hỏa tốc hẹn giờ'
      default:
        return ''
    }
  }

  const documentHandleDropdown = (
    <Menu>
      {statusId != 1 && (
        <Menu.Item onClick={() => handleReceived()}>Nhận văn bản</Menu.Item>
      )}
      {/* {statusId == 2 && (
        <Menu.Item onClick={() => handleReceived}>Nhận văn bản</Menu.Item>
      )} */}
      <Menu.Item onClick={() => handleNY()}>Chưa xử lý</Menu.Item>{' '}
      <Menu.Item onClick={() => handleProcessing()}>Đang xử lý</Menu.Item>{' '}
      <Menu.Item onClick={() => handleFinish()}>Hoàn thành xử lý</Menu.Item>
      {/* <Menu.Item
        danger
        onClick={() => message.warning('Chức năng đang cập nhật!')}>
        Xóa văn bản
      </Menu.Item> */}
    </Menu>
  )

  const handleReceived = () => {
    loadingAnimationStore.showSpinner(true)
    cateDocumentStore
      .updateReceivedStatus({ id: documentId, status_id: 1 })
      .then(() => {
        message.success('Nhận văn bản thành công!')
        fetchData()
      })
      .catch(error => {
        console.log(error)
        message.error(error.vi)
      })
      .finally(() => {
        loadingAnimationStore.showSpinner(false)
      })
  }

  const handleNY = () => {
    loadingAnimationStore.showSpinner(true)
    cateDocumentStore
      .updateReceivedStatus({ id: documentId, status_id: 2 })
      .then(() => {
        message.success('Cập nhật trạng thái chưa xử lý văn bản thành công!')
        fetchData()
      })
      .catch(error => {
        message.error(error.vi)
      })
      .finally(() => {
        loadingAnimationStore.showSpinner(false)
      })
  }

  const handleProcessing = () => {
    loadingAnimationStore.showSpinner(true)
    cateDocumentStore
      .updateReceivedStatus({ id: documentId, status_id: 4 })
      .then(() => {
        message.success('Cập nhật trạng thái đang xử lý văn bản thành công!')
        fetchData()
      })
      .catch(error => {
        message.error(error.vi)
      })
      .finally(() => {
        loadingAnimationStore.showSpinner(false)
      })
  }

  const handleFinish = () => {
    loadingAnimationStore.showSpinner(true)
    cateDocumentStore
      .updateReceivedStatus({ id: documentId, status_id: 5 })
      .then(() => {
        message.success(
          'Cập nhật trạng thái hoàn thành xử lý văn bản thành công!'
        )
        fetchData()
      })
      .catch(error => {
        message.error(error.vi)
      })
      .finally(() => {
        setShowFinish(false)
        loadingAnimationStore.showSpinner(false)
      })
  }

  const { currentUser } = authenticationStore
  useEffect(() => {
    if (!currentUser) return
    loadingAnimationStore.showSpinner(true)
    companyStore
      .getUserListWithRole('', currentUser.company.code)
      .finally(() => loadingAnimationStore.showSpinner(false))
    return () => {
      companyStore.clearAllUserList()
    }
  }, [currentUser])
  return (
    <DashboardLayout>
      <Helmet>
        <title>{`${title} | ${systemName} Quản lý VB nội bộ`}</title>
      </Helmet>

      <PageTitle
        location={props.location}
        title={title ? title : 'Undefined'}
        showTitle={true}
        color={commonStore.appTheme.solidColor}>
        <HeadingButtonWrapper>
          {}
          <Button style={{ marginLeft: 10 }} onClick={reloadIncoming}>
            <ReloadOutlined />
            Nạp lại văn bản
          </Button>
          <Dropdown overlay={documentHandleDropdown} trigger={['click']}>
            <span className={'btn-style'}>
              <MoreOutlined />
            </span>
          </Dropdown>
        </HeadingButtonWrapper>
      </PageTitle>
      <DocumentContentWrapper>
        <BlockLeft>{renderAttachmentFile}</BlockLeft>

        <BlockRight>
          <ContentBlockWrapper>
            <TitleContentBox>Thông tin chung</TitleContentBox>
            <DocumentInfoList>
              {/* <dt>Loại nghiệp vụ VB</dt>
              <dd>
                {bussiness_doc_type &&
                  renderBussinessDocTypeName(bussiness_doc_type)}
              </dd> */}
              <dt>Số hiệu</dt>
              <dd>{documentNumber && documentNumber}</dd>
              <dt>Loại văn bản</dt>
              <dd>{type && CATE_DOCUMENT_TYPE[type]?.value}</dd>
              <dt>Tên loại văn bản</dt>
              <dd>{typeName}</dd>
              <dt>CQ ban hành</dt>
              <dd>{from_organ && WordBreak(from_organ?.organName)}</dd>
              <dt>Độ quan trọng</dt>
              <dd>
                {priorityId !== null && DOCUMENT_PRIORITY[priorityId]?.value}
              </dd>
              <dt>Ngày ban hành</dt>
              <dd>
                {promulgationDate && (
                  <>
                    <CalendarOutlined style={{ color: blue, marginRight: 4 }} />
                    <span>
                      {moment(promulgationDate).format(DATE_FORMAT_DEFAULT)}
                    </span>
                  </>
                )}
              </dd>
              <dt>Người ký</dt>
              <dd>{fullname}</dd>
              <dt>Trạng thái</dt>
              <dd>{getDOCUMENT_STATUS_RECEIVED(statusId)}</dd>
              <dt>Loại chỉ đạo</dt>
              <dd>
                {steeringType !== undefined &&
                  STEERING_TYPE[steeringType]?.value}
              </dd>
              {/* {edocs_bussiness &&
                edocs_bussiness.length > 0 &&
                edocs_bussiness.map(item => (
                  <Fragment key={item.doc_id}>
                    <dt>{`Văn bản bị ${renderAction(bussiness_doc_type)}`}</dt>
                    <dd>
                      <Tooltip title={item.title}>
                        <Link
                          to={`/connected-committee-document/incoming-document/view/${item.doc_id}`}>
                          {item.code}
                        </Link>
                      </Tooltip>
                    </dd>
                  </Fragment>
                ))} */}
              <dt>Tài liệu đính kèm</dt>
              <dd>
                <div>
                  {attachments ? (
                    attachments.map(file => (
                      <FileItem
                        key={file.fileId}
                        file_id={file.fileId}
                        file_name={file.fileName}
                        file_type={utils.getExtensionFile(file.fileName)}
                      />
                    ))
                  ) : (
                    <EmptyText>Không có tài liệu đính kèm.</EmptyText>
                  )}
                  {/* {attachments &&
                    attachments.map(file => (
                      <div key={file} style={{ display: 'block' }}>
                        <FilePdfOutlined style={{ color: redPrimary }} />
                        &nbsp;
                        <a
                          className={'file-item'}
                          onClick={() => handleDownloadAttachment(file)}
                          key={file}>
                          {file}
                        </a>
                      </div>
                    ))} */}
                </div>
              </dd>
              {/* <dt>EDXML</dt>
              <dd>
                <a onClick={handleDownloadDocumentEDXML}>Tải file</a>
              </dd> */}
            </DocumentInfoList>
          </ContentBlockWrapper>
          <div style={{ marginBottom: 15 }} />
          <ContentBlockWrapper>
            <ConnectedCommitteeDocumentIncomingHistoryBlock
              title={'Lịch sử văn bản đến'}
              history={history}
            />
          </ContentBlockWrapper>
        </BlockRight>
      </DocumentContentWrapper>
      <ConnectedCommitteeDocumentUserReadingStatusModal
        modalVisible={showUserReadingModal}
        onClose={() => setShowUserReadingModal(false)}
      />
    </DashboardLayout>
  )
}

CateDocumentIncomingDocDetailPage.propTypes = {}

export default inject(
  'commonStore',
  'cateDocumentStore',
  'loadingAnimationStore',
  'authenticationStore',
  'companyStore',
  'fileStore'
)(observer(CateDocumentIncomingDocDetailPage))
